import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { compact } from 'lodash'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Plans from './tabs/Plans'
import Roles from './tabs/Roles'

const FARM_PLANS_MANAGEMENT_SLUG = 'gerenciamento-de-planos-farm'
const FARM_ROLES_MANAGEMENT_SLUG = 'gerenciamento-de-papeis-fazenda-farm'

const FarmConfigurationsScreen = () => {
  const { pathname } = useLocation()
  const { routes, urlHasPermission } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = (tab) => {
        if (urlHasPermission(tab.slug, 'company')) {
          response.push(tab)
        }
      }

      addTab({
        slug: FARM_PLANS_MANAGEMENT_SLUG,
        route: 'plans',
        title: t('plan', { howMany: 2 }),
        Component: () => <Plans slug={ FARM_PLANS_MANAGEMENT_SLUG } />
      })
      addTab({
        slug: 'gerenciamento-de-papeis-fazenda-farm',
        route: 'roles',
        title: t('role', { howMany: 2 }),
        Component: () => <Roles slug={ FARM_ROLES_MANAGEMENT_SLUG } />
      })

      return response
    },
    [t, urlHasPermission]
  )

  const crumbs = useMemo(() => compact([
    {
      title: routes.farmSettings.title,
      key: 'farm-configurations-screen',
      url: '/settings/farm',
      active: pathname === '/settings/farm'
    },
    (
      pathname.includes('plans') ? {
        title: t('plan', { howMany: 2 }),
        key: 'farm-plans-screen',
        url: '/settings/farm/plans',
        active: pathname === '/settings/farm/plans'
      } : null
    ),
    (
      pathname.includes('roles') ? {
        title: t('role', { howMany: 2 }),
        key: 'farm-roles-screen',
        url: '/settings/farm/roles',
        active: pathname === '/settings/farm/roles'
      } : null
    )
  ]), [pathname, routes.farmSettings.title, t])

  return (
    <Screen title={ routes.farmSettings.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default FarmConfigurationsScreen
